import { Cookies } from 'react-cookie';

export const ATTRIBUTION_COOKIE_NAME = 'qc_attribution';

// Last-touch click-source param the marketing site stamps on app links; maps to SignupAttribution.signup_channel.
const CHANNEL_PARAM = 'qc_channel';

const URL_ATTRIBUTION_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid',
  'twclid',
  'ttclid',
] as const;

export type SignupAttribution = Record<string, string>;

// Ad pixels set their own cookies; read them at signup since they may post-date the first touch.
const readPlatformCookies = (cookies: Cookies): SignupAttribution => {
  const out: SignupAttribution = {};
  const oppref = cookies.get('__oppref', { doNotParse: true });
  if (oppref) out.oppref = String(oppref);
  const ga = cookies.get('_ga', { doNotParse: true });
  if (ga) {
    // `_ga` is "GA1.<scope>.<clientId>"; the GA4 client id is the trailing "X.Y".
    const clientId = String(ga).split('.').slice(2).join('.');
    if (clientId) out.ga_client_id = clientId;
  }
  return out;
};

// First-touch cookie (set on .quickchat.ai by the marketing site) wins; URL params and
// freshly-read pixel cookies fill any gaps.
export const readSignupAttribution = (): SignupAttribution | undefined => {
  const cookies = new Cookies();
  const cookie = cookies.get(ATTRIBUTION_COOKIE_NAME);
  const cookieData = cookie && typeof cookie === 'object' ? (cookie as SignupAttribution) : {};

  const params = new URLSearchParams(window.location.search);
  const urlData: SignupAttribution = {};
  URL_ATTRIBUTION_PARAMS.forEach((key) => {
    const value = params.get(key);
    if (value) urlData[key] = value;
  });
  const channel = params.get(CHANNEL_PARAM);
  if (channel) urlData.signup_channel = channel;

  const attribution = { ...urlData, ...readPlatformCookies(cookies), ...cookieData };
  return Object.keys(attribution).length > 0 ? attribution : undefined;
};
